<template lang="html">
  <rate-dialog
    title='Create Rate'
    v-model="valid">
    <template #activator=' { on } '>
      <slot name='activator' :on='on'>
        <v-btn
          flat
          color='info'
          v-on='on'>
          Create
        </v-btn>
      </slot>
    </template>
    <template #input>
      <v-flex xs12>
        <v-switch v-model='payload.saved'>
          <template #label>
            <span>This rate will {{ `${ payload.saved ? '' : 'not' }` }} be saved</span>
            <v-tooltip bottom>
              <template #activator=' { on } '>
                <v-icon v-on='on'>
                  mdi-help-circle
                </v-icon>
              </template>
              <span>
                All rates will be saved, but are only reusable if
                explicitly marked here
              </span>
            </v-tooltip>
          </template>
        </v-switch>
      </v-flex>
      <v-flex
        v-for='(value, propertyName) in payload'
        v-if='displayProp(propertyName)'
        :key='propertyName'
        xs12
        md6>
        <v-text-field
          :label='fieldLabel(propertyName)'
          v-model='payload[propertyName]'
          :disabled="propertyName === 'name' && !payload.saved"
          :rules="propertyName === 'name' ? nameRules : rateRules"/>
      </v-flex>
    </template>
    <template #actions=' { deactivate } '>
      <slot name='actions' :deactivate='deactivate'>
        <v-btn
          color='warning'
          v-on='deactivate'>
          Cancel
        </v-btn>
        <v-btn
          color='primary'
          v-on='deactivate'
          @click='submit'>
          Submit
        </v-btn>
      </slot>
    </template>
  </rate-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import label from '@/utils/label'
import uuid from '@/utils/uuid'
import RateDialog from './RateDialog'
import RulesFactory from '@/utils/validation/RulesFactory'
export default {
  components: {
    'rate-dialog': RateDialog
  },
  props: {
  },
  data: vm => ({
    payload: {},
    save: false,
    valid: true,
    rateRules: RulesFactory.get('rates'),
    nameRules: RulesFactory.get('name')
  }),
  computed: {
    displayProp: () => prop => !['id', 'type', 'dispatch', 'saved'].includes(prop),
    fieldLabel: () => prop => label(prop),
    createdRate () {
      return {
        value: this.rateByName(this.payload.name) ?
          this.rateByName(this.payload.name).id :
          null,
        text: this.rateByName(this.payload.name) ?
          this.rateByName(this.payload.name).name :
          null
      }
    },
    ...mapGetters('dispatch', { dispatchId: 'id' }),
    ...mapGetters('rates', { rateByName: 'byName' })
  },
  mounted () {
    this.payload = this.createFreshForm();
  },
  methods: {
    createFreshForm () {
      return {
        name: uuid(),
        saved: false,
        live_rate: null,
        dead_rate: null,
        type: 'm',
        dispatch: this.dispatchId,
        layover: null,
        extra_driver: null,
        misc_cost: null,
        hourly: null,
        gratituity: null,
        day_rate: null,
        leg_rate: null
      }
    },
    submit () {
      return this.createRate(this.payload).then(
        () => {
          this.$emit('created', this.createdRate.value)
          this.payload = this.createFreshForm()  // would it be better to destroy here?
        }).catch( e => this.raiseError(e))
    },
    ...mapActions('rates', { createRate: 'create' }),
    ...mapActions('app', ['raiseError'])
  }
}
</script>

<style lang="css" scoped>
</style>
